import { useCallback, useRef } from 'react';
import { START_SCROLL_CONFIGURATION } from 'data/global';

export default function useScrollToStart() {
  const container = useRef<HTMLDivElement>(null);

  const scrollToStart = useCallback(
    () =>
      setTimeout(
        () => container?.current?.scrollTo(START_SCROLL_CONFIGURATION),
        0,
      ),
    [],
  );

  return [container, scrollToStart] as const;
}
